import { AppRouter } from "./router";
import { useTheme } from "./hooks/useTheme";

const App = () => {
  useTheme();

  return <AppRouter />;
};

export { App };
